import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';
import { primitive } from 'styles/constants/primitives';

export const MaxWidth = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  width: 100%;
`;

export const HeaderBackground = styled.div`
  background-color: ${p => p.theme.token('background-active')};
  border-block-start: 1px solid ${p => p.theme.token('border-color-default')};
  margin-block-end: ${primitive.$spacing2};
`;

export const HeaderWrapper = styled.div`
  color: ${p => p.theme.token('text-reversed')};

  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 1000px;
  width: 100%;
`;

export const Header = styled.h1`
  font: ${brandFont.headerOne};
  font-weight: ${Styles.fontWeight.heavy};
`;

export const BackHeaderButton = styled.div`
  position: absolute;
  cursor: pointer;
  inset-inline-start: ${primitive.$spacing2};
`;

export const MaxWidthFullHeight = styled(MaxWidth)`
  height: 100%;
`;

export const ToggleViewButtonWrapper = styled.div`
  position: absolute;
  inset-inline-end: ${primitive.$spacing2};
`;

export const ServiceModeCategoryToggleWrapper = styled.div`
  padding: ${primitive.$spacing2} ${primitive.$spacing4};

  display: flex;
  justify-content: center;

  fieldset {
    margin: 0;
  }

  legend {
    display: none;
  }

  ${Styles.mobile} {
    width: 100%;
  }
`;

export const SearchBarWrapper = styled.div<{ $showStoreLocator?: boolean }>`
  padding: ${primitive.$spacing2} ${primitive.$spacing4};
  width: 100%;
  height: ${p => (p.$showStoreLocator ? '80px' : '')};
  white-space: initial;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  ${Styles.desktop} {
    flex-direction: row;
  }
`;

export const SearchContainer = styled(FlexContainer)`
  padding-block-end: ${primitive.$spacing2};
`;

export const BackArrow = styled.div`
  padding: 1rem 0.8rem;
`;

export const ConfirmHeader = styled.div`
  display: flex;
`;

export const ConfirmHeaderTitle = styled.h1`
  font-size: 1rem;
  font-weight: bold;
  padding-block: 1rem;
  padding-inline-start: 0;
  padding-inline-end: 4rem;
  margin: 0 auto;
`;
